module.exports = __webpack_public_path__ + "img/3-01_mb.d8cf4ee8.png";